<div *ngIf="abierto">

  <div class="backdrop negro"></div>

  <div class="panelDialogo animated {{animacion}}">
    <div class="panelBody">


      <div class="contenido">

        <!-- Icono -->
        <div class="iconoDialo {{claseIcono}}">
          <span class="fa {{icono}}"></span>
        </div>

        <!-- Titulo -->
        <div class="tituloDialogoMensaje"  *ngIf="dialogo.Titulo" [ngClass]="{'espacioSeccionDialogo': icono}">
          <span >{{dialogo.Titulo}}</span>
        </div>

        <!-- Mensaje -->
        <div class="mensajeDialogoMensaje" *ngIf="dialogo.Mensaje" [ngClass]="{'espacioSeccionDialogo': (icono || dialogo.Titulo)}">
          <div [innerHTML]="dialogo.Mensaje | HtmlSeguro"></div>
        </div>

      </div>

      <div class="divisor24"></div>

      <!-- Operaciones -->
      <div class="panelDialogoBtn">
        <button  *ngFor="let opt of dialogo.Opcion; let last = last" class="btn boton redondeado botonSM botonMensaje" [ngClass]="{'filled': TipoOpcionEnum.positivo == opt.Tipo, 'filledBlanco' : TipoOpcionEnum.negativo == opt.Tipo}" (click)="CerrarDialogo(opt.Valor)" >
          {{opt.Titulo}}
        </button>
      </div>


    </div>
  </div>
</div>
